import BadGuy from "./BadGuy";

export default class Bat extends BadGuy
{
    constructor(speed:number) {
        super(speed);

        this.el.classList.add('Bat');
    }
}
